import styled from 'styled-components';

export const AICardLink = styled.a<{ disabled?: boolean }>`
    ${({ disabled }) =>
        disabled &&
        `
        pointer-events: none;
        opacity: 0.5;
    `}
`;

export const AICardContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    gap: 8px;

    .ai-card-header {
        display: flex;
        justify-content: space-between;
        gap: 8px;

        .ai-card-label-container {
            display: flex;
            align-items: center;
            gap: 8px;
            font-weight: bold;

            .ai-card-label {
                display: flex;
                align-items: center;
                gap: 6px;
            }
        }
    }
`;

export const AICardActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 12px;

    &:empty {
        display: none;
    }
`;

export const RefreshIcon = styled.div`
    color: #005ba8;

    svg {
        color: #005ba8;
    }
`;
